export const appNameHeader = {
  'app-name': 'indstocks',
}

export const TRACE_ID_KEY = 'X-Amzn-Trace-Id'
